<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row v-if="$role != 'teacher'">
            <b-col lg="6" class="mb-md-0 mb-2">
              <b-form-group
                id="input-group-3"
                :label="$t('edu_courses.edu_courses')"
                label-for="input-3"
              >
                <validation-provider
                  v-if="!newItem.id"
                  #default="{ errors }"
                  :name="$t('edu_courses.edu_courses')"
                  vid="edu_course"
                  rules="required"
                >
                  <v-select
                    v-model="newItem.edu_course_edu_program"
                    :options="edu_courses.courses"
                    class="w-100"
                    label="for_v_select"
                    :state="errors.length > 0 ? false : null"
                    multiple
                  />
                  <!-- <v-select
                  v-model="newItem.edu_course_id"
                  :options="edu_courses"
                  class="w-100"
                  label="for_v_select"
                  :reduce="(type) => type.id"
                  :state="errors.length > 0 ? false : null"
                  multiple
                  v-else
                /> -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <b-badge v-else variant="success"
                  ><feather-icon icon="StarIcon" class="mr-75" />
                  <span v-for="edu_course in edu_courses">{{
                    edu_course.id === newItem.edu_course_id
                      ? edu_course.for_v_select
                      : ""
                  }}</span>
                </b-badge>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('activities.name')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('activities.name')"
                  vid="activity_name"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.name"
                    type="text"
                    :placeholder="$t('activities.name')"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <div class="form-group">
                <label>{{ $t("activities.start_date") }}</label>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('activities.start_date')"
                  vid="start_date"
                  rules="required"
                >
                  <b-datepicker
                    v-model="newItem.start_date"
                    :state="errors.length > 0 ? false : null"
                  ></b-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <b-col lg="6">
              <div class="form-group">
                <label>{{ $t("activities.end_date") }}</label>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('activities.end_date')"
                  vid="end_date"
                  rules="required"
                >
                  <b-datepicker
                    v-model="newItem.end_date"
                    :min="newItem.start_date"
                    :state="errors.length > 0 ? false : null"
                  ></b-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <b-col lg="4">
              <b-form-group
                id="input-group-3"
                :label="$t('activities.type')"
                label-for="input-3"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('activities.type')"
                  vid="activity_type"
                  rules="required"
                >
                  <v-select
                    v-model="newItem.type"
                    :options="types"
                    class="w-100"
                    label="value"
                    :reduce="(type) => type.key"
                    v-on:input="handle"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                id="input-group-1"
                :label="$t('activities.grade')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('activities.grade')"
                  vid="activity_grade"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.grade"
                    type="number"
                    :placeholder="$t('activities.grade')"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2" v-if="$role == 'teacher'">
              <b-form-group
                id="input-group-3"
                :label="$t('activities.save_questions')"
                label-for="input-3"
              >
                <b-form-checkbox
                  v-model="save_questions"
                  :value="true"
                  class="custom-control-success"
                  @change="check($event)"
                />
              </b-form-group>
              <!-- </b-form-checkbox> -->
            </b-col>
            <b-col lg="2" v-if="newItem.type == 'short_search'">
              <b-form-group
                id="input-group-3"
                label="غير محدود"
                label-for="input-3"
              >
                <b-form-checkbox
                  v-model="newItem.unlimited"
                  value="1"
                  unchecked-value="0"
                  class="custom-control-success"
                /> </b-form-group
            ></b-col>
          </b-row>
          <hr />
          <b-row
            v-if="
              (['forum', 'short_search'].includes(newItem.type) &&
                save_questions &&
                newItem.id) ||
              (['forum', 'short_search'].includes(newItem.type) &&
                $role == 'teacher')
            "
          >
            <b-col lg="12">
              <b-form>
                <b-row>
                  <b-col lg="10">
                    <b-form-group
                      id="input-group-1"
                      :label="$t('activities.' + newItem.type)"
                      label-for="input-1"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('activities.question')"
                        vid="forum_question"
                        rules="required"
                      >
                        <b-form-input
                          id="input-1"
                          v-model="newItem.forum_or_short_search"
                          type="text"
                          :placeholder="$t('activities.question')"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
          <b-row
            v-if="
              (newItem.type == 'homework' && save_questions && newItem.id) ||
              (newItem.type == 'homework' && $role == 'teacher')
            "
          >
            <b-col lg="12">
              <b-form>
                <b-row v-for="(q, k) in homeWork" :key="k">
                  <b-col lg="10">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('activities.question') + '_' + k"
                      :vid="'exam_question' + '_' + k"
                      rules="required"
                    >
                      <b-form-input
                        v-model="q.question"
                        type="text"
                        :placeholder="$t('activities.question')"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                  <b-col lg="2">
                    <b-btn
                      block
                      variant="danger"
                      class="btn-danger btn-sm"
                      type="button"
                      v-show="homeWork.length > 1 && k === homeWork.length - 1"
                      @click="removeHomeWork(k)"
                      >{{ $t("site.delete") }}</b-btn
                    >
                    <b-btn
                      block
                      variant="success"
                      class="btn-success btn-sm"
                      type="button"
                      v-show="k === homeWork.length - 1"
                      @click="addHomeWork(k)"
                      >{{ $t("site.add") }}</b-btn
                    >
                  </b-col>
                  <br /><br /><br />
                </b-row>
              </b-form>
            </b-col>
          </b-row>
          <b-row
            v-if="
              (newItem.type == 'exam' && save_questions && newItem.id) ||
              (newItem.type == 'exam' && $role == 'teacher')
            "
          >
            <b-col lg="12">
              <b-form v-for="(q, k) in exam" :key="k">
                <b-row>
                  <b-col lg="10">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('activities.question') + '_' + k"
                      :vid="'exam_question' + '_' + k"
                      rules="required"
                    >
                      <b-form-input
                        v-model="q.question"
                        type="text"
                        :placeholder="$t('activities.question')"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                  <b-col lg="2">
                    <b-btn
                      block
                      variant="danger"
                      class="btn-danger btn-sm"
                      type="button"
                      v-show="exam.length > 5 && k === exam.length - 1"
                      @click="removeExam(k)"
                      >{{ $t("site.delete") }}</b-btn
                    >
                    <b-btn
                      block
                      variant="success"
                      class="btn-success btn-sm"
                      type="button"
                      v-show="k === exam.length - 1"
                      @click="addExam(k)"
                      >{{ $t("site.add") }}</b-btn
                    >
                  </b-col>
                </b-row>
                <br />
                <b-row v-for="(answer, ke) in q.answers" :key="ke">
                  <b-col lg="6">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('activities.answer') + '_' + k + '_' + ke"
                      :vid="'exam_answer' + '_' + k + '_' + ke"
                      rules="required"
                    >
                      <b-form-input
                        v-model="answer.answer"
                        type="text"
                        :placeholder="$t('activities.answer')"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                  <b-col lg="2">
                    <!-- <validation-provider
                        #default="{ errors }"
                        :name="$t('activities.answer')"
                        :rules="{ oneOf: ['1','2','3','4'] }"
                      >   -->
                    <b-form-radio
                      v-model="answer.type"
                      name="answer"
                      :value="1"
                      @change="log(k, ke)"
                      class="custom-control-success"
                    >
                    </b-form-radio>
                    <!-- <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>    -->
                  </b-col>
                  <b-col lg="2">
                    <b-btn
                      block
                      variant="danger"
                      class="btn-danger btn-sm"
                      type="button"
                      v-show="
                        q.answers.length > 2 && ke === q.answers.length - 1
                      "
                      @click="removeAnswer(k, ke)"
                      >{{ $t("site.delete") }}</b-btn
                    >
                    <b-btn
                      block
                      variant="success"
                      class="btn-success btn-sm"
                      type="button"
                      v-show="ke === q.answers.length - 1"
                      @click="addAnswer(k)"
                      >{{ $t("site.add") }}</b-btn
                    >
                  </b-col>
                </b-row>
                <br /><br />
                <hr />
              </b-form>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="
                  invalid ||
                  (selected_answers.length < exam.length &&
                    newItem.type == 'exam' &&
                    save_questions) ||
                  (selected_answers.length < exam.length &&
                    newItem.type == 'exam' &&
                    $role == 'teacher')
                "
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form></validation-observer
      >
    </b-col>
  </b-row>
</template>

<script>
import Controller from "../../../../Controllers/ActivitiesController";
import EduCoursesController from "@/Controllers/EduCoursesController";
import EduProgramsController from "@/Controllers/EduProgramsController";
import config from "../../../../config/config";
import vSelect from "vue-select";
import Auth from "@/Apis/Auth";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
// import { oneOf } from "vee-validate/dist/rules";
// extend("oneOf", {
//   ...oneOf,
//   message: "Choose one",
// });

const controller = new Controller();
export default {
  name: "ActivitiesForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    vSelect,
  },
  props: ["newItem", "homeWork", "exam"],
  data() {
    return {
      file: {},
      
      season: {},
      types: [],
      edu_courses: [],
      selected_answers: [],
      seleced_ids: [],
      save_questions: false,
      account_type:Auth.USER.account_type 
    };
  },
  async created() {
    if (Auth.USER.account_type == "teacher") {
      const res = await new Controller().teacherCourses({
        edu_program: localStorage.getItem("eduProgram"),
      });
      if (res) {
        res.map((e) => {
          this.edu_courses.push(e.course);
        });
        this.edu_courses.forEach((el) => {
          el.for_v_select = el.code + " " + el.name;
        });
      }
    } else {

      this.edu_courses = await new EduCoursesController().GetAllCourses();
      console.log(this.edu_courses);

        this.edu_courses.courses.forEach((el) => {
          el.for_v_select = el.name;
        });
    }
    let t = ["forum", "homework", "short_search", "exam", "master"];
    t.forEach((val) => {
      this.types.push({
        key: val,
        value: this.$i18n.t("activities." + val),
      });
    });
  },
  methods: {
    check(event) {
      this.save_questions = event;
      // console.log(event);
    },
    log(k, ke) {
      console.log(this.exam.length, this.selected_answers.length);
      this.exam[k].answers.map((element, index) => {
        if (index == ke) {
          element.type = 1;
        } else {
          element.type = 0;
        }
      });
      this.seleced_ids.push(k);
      this.selected_answers = [...new Set(this.seleced_ids)];
    },

    handle(key) {
      // console.log(this.exam);
    },
    addHomeWork(k) {
      this.homeWork.push({
        question: "",
      });
    },
    addExam(k) {
      this.exam.push({
        question: "",
        answers: [
          {
            answer: "",
            type: 0,
          },
          {
            answer: "",
            type: 0,
          },
        ],
      });
    },
    addAnswer(k) {
      this.exam[k].answers.push({
        answer: "",
        type: 0,
      });
      // console.log(this.exam);
    },
    removeHomeWork(k) {
      this.homeWork.splice(k, 1);
    },
    removeExam(k) {
      console.log(k);
      this.exam.splice(k, 1);
    },
    removeAnswer(k, ke) {
      this.exam[k].answers.splice(ke, 1);
    },
    addQuestion() {
      // console.log(this.newItem);
    },
    goToTable() {
      console.log("manaa");
      this.save_questions = false;
      this.homeWork = [
        {
          question: "",
        },
        // {
        //   question: "",
        // },
        // {
        //   question: "",
        // },
      ];
      (this.exam = [
        {
          question: "",
          answers: [
            {
              answer: "",
              type: 0,
            },
            {
              answer: "",
              type: 0,
            },
          ],
        },
        {
          question: "",
          answers: [
            {
              answer: "",
              type: 0,
            },
            {
              answer: "",
              type: 0,
            },
          ],
        },
        {
          question: "",
          answers: [
            {
              answer: "",
              type: 0,
            },
            {
              answer: "",
              type: 0,
            },
          ],
        },
        {
          question: "",
          answers: [
            {
              answer: "",
              type: 0,
            },
            {
              answer: "",
              type: 0,
            },
          ],
        },
        {
          question: "",
          answers: [
            {
              answer: "",
              type: 0,
            },
            {
              answer: "",
              type: 0,
            },
          ],
        },
      ]),
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.dataHandle();
      const ctr = new Controller();
      if (Auth.USER.account_type == "teacher")
        await ctr.updateTeacher(this.newItem);
      else await ctr.From(this.newItem, "FormData");

      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
      this.selected_answers = [];
      this.save_questions = false;
      this.homeWork = [
        {
          question: "",
        },
        // {
        //   question: "",
        // },
        // {
        //   question: "",
        // },
      ];
      this.exam = [
        {
          question: "",
          answers: [
            {
              answer: "",
              type: 0,
            },
            {
              answer: "",
              type: 0,
            },
          ],
        },
        {
          question: "",
          answers: [
            {
              answer: "",
              type: 0,
            },
            {
              answer: "",
              type: 0,
            },
          ],
        },
        {
          question: "",
          answers: [
            {
              answer: "",
              type: 0,
            },
            {
              answer: "",
              type: 0,
            },
          ],
        },
        {
          question: "",
          answers: [
            {
              answer: "",
              type: 0,
            },
            {
              answer: "",
              type: 0,
            },
          ],
        },
        {
          question: "",
          answers: [
            {
              answer: "",
              type: 0,
            },
            {
              answer: "",
              type: 0,
            },
          ],
        },
      ];
    },
    dataHandle() {
      this.newItem.user_id = Auth.USER.id;
      if (this.newItem.type === "homework") {
        this.newItem.questions = this.homeWork;
        // this.homeWork=[
        //     {
        //       question:"",
        //     },
        //     {
        //       question:"",
        //     },
        //     {
        //       question:"",
        //     },
        // ];
      }
      if (this.newItem.type === "exam") {
        this.newItem.questions = this.exam;
        // this.exam=[
        //       {
        //         question:"",
        //         answers:[
        //           {
        //             answer:'',
        //             type:0
        //           },
        //           {
        //             answer:'',
        //             type:0
        //           }
        //         ]
        //       },
        //       {
        //         question:"",
        //         answers:[
        //           {
        //             answer:'',
        //             type:0
        //           },
        //           {
        //             answer:'',
        //             type:0
        //           }
        //         ]
        //       },
        //       {
        //         question:"",
        //         answers:[
        //           {
        //             answer:'',
        //             type:0
        //           },
        //           {
        //             answer:'',
        //             type:0
        //           }
        //         ]
        //       },
        //       {
        //         question:"",
        //         answers:[
        //           {
        //             answer:'',
        //             type:0
        //           },
        //           {
        //             answer:'',
        //             type:0
        //           }
        //         ]
        //       },
        //       {
        //         question:"",
        //         answers:[
        //           {
        //             answer:'',
        //             type:0
        //           },
        //           {
        //             answer:'',
        //             type:0
        //           }
        //         ]
        //       },
        //       ];
      }
    },
  },
};
</script>
